// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36g-5","left":"styles_left__1SV3Y"};